module.exports = __webpack_public_path__ + "static/media/python.3b84eb40.svg";